import { render, staticRenderFns } from "./CustomSideMenu.vue?vue&type=template&id=46b58099"
import script from "./CustomSideMenu.vue?vue&type=script&lang=js"
export * from "./CustomSideMenu.vue?vue&type=script&lang=js"
import style0 from "./CustomSideMenu.vue?vue&type=style&index=0&id=46b58099&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports